import React from 'react'

export default function Step(props) {
  const { title, subtitle, icon, description, linkLabel, linkUrl, bottomInfo } =
    props

  return (
    <React.Fragment>
      <div className="step shadow-sm">
        <div className="header">
          {icon && <img className="icon" src={icon} />}
          <span className="title">{title}</span>
        </div>

        <div className="body">
          <div className="subtitle">{subtitle}</div>

          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></div>
        </div>

        <div className="footer">
          {linkUrl && (
            <a className="link" href={linkUrl}>
              {linkLabel}
            </a>
          )}

          {bottomInfo && <div className="bottom-info">{bottomInfo}</div>}
        </div>
      </div>
    </React.Fragment>
  )
}
